import * as sicredi from './extratoSicrediParser';
import * as sicoob from './extratoSicoobParser';
import * as pagSeguro from './extratoPagSeguroParser';
import * as mercadoPago from './extratoMercadoPagoParser';
import * as cappta from './extratoCapptaParser';
import * as tuna from './extratoTunaParser';
import * as santander from './extratoSantanderParser';

export const detectAndProcess = (dadosArray) => {
    // Tenta Santander
    if (santander.detectar(dadosArray)) {
        return santander.processar(dadosArray);
    }

    // Tenta Tuna (Bancario)
    if (tuna.detectar(dadosArray)) {
        return tuna.processar(dadosArray);
    }

    // Tenta Mercado Pago (assinatura clara em inglês)
    if (mercadoPago.detectar(dadosArray)) {
        return mercadoPago.processar(dadosArray);
    }
    
    // Tenta PagSeguro primeiro (Ele e o Sicoob possuem o mesmo cabeçalho na linha 1, mas o PagSeguro tem colunas específicas)
    if (pagSeguro.detectar(dadosArray)) {
        return pagSeguro.processar(dadosArray);
    }
    
    // Tenta Sicoob
    if (sicoob.detectar(dadosArray)) {
        return sicoob.processar(dadosArray);
    }
    
    // Tenta Cappta
    if (cappta.detectar(dadosArray)) {
        return cappta.processar(dadosArray);
    }
    
    // Fallback: Sicredi (ou outro que encaixe na estrutura clássica)
    if (sicredi.detectar(dadosArray)) {
        return sicredi.processar(dadosArray);
    }

    // Lança erro caso não consiga detectar
    throw new Error('Formato de extrato bancário não reconhecido. Certifique-se de que é um arquivo válido do Sicredi, Sicoob, PagSeguro, Mercado Pago, Cappta ou Bancário Tuna.');
};
